// Routes exempt from the inactivity auto-logout enforced by `useIdleTimer`.
//
// The idle-logout is a walk-away / console-attacker guard (see
// docs/plans/2026-04-29-ws-security-ux-design.md). Admin operators, however,
// watch live dashboards (sessions, instances, crawl stats) for long stretches
// without any mouse/keyboard input, so the 30-minute idle-logout kicked them
// to the login screen mid-watch — reported 2026-06-26. Admin pages are
// therefore exempt; the guard still applies to every other authenticated route.
export const IDLE_LOGOUT_EXEMPT_PREFIXES = ['/admin'] as const;

/**
 * True when `pathname` falls under a route exempt from idle auto-logout.
 * Matches the prefix exactly or as a path segment boundary (`/admin` and
 * `/admin/...` match; `/administrators` does not).
 */
export function isIdleLogoutExemptPath(
  pathname: string | null | undefined,
): boolean {
  if (!pathname) return false;
  return IDLE_LOGOUT_EXEMPT_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
